import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { NgIf } from '@angular/common';
@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    animations: [
        trigger('dialog', [
            transition('void => *', [
                style({
                    transform: 'translateY(-90vh)'
                }),
                animate(300)
            ]),
            transition('* => void', [
                animate(300, style({
                    transform: 'translateY(-90vh)',
                }))
            ])
        ])
    ],
    imports: [NgIf]
})
export class ModalComponent implements OnInit {
  // Inputs
  @Input() closable = true;
  @Input() cancelable = true;
  @Input() visible: boolean = false;
  @Input() closeColor = '#2d2d2d';
  @Input() modalWidth = '30vw';
  @Input() modalMinHeight = '200px';
  @Input() modalTop = '110px';

  // Outputs
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() modalClosed: EventEmitter<boolean> = new EventEmitter<boolean>();

  dynamicTop: any = 0;

  constructor(
    public companyParamsService: CompanyParamsService,
  ) { }

  ngOnInit() { }

  close() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  animationEnded(event: any) {
    if (!this.visible) {
      this.modalClosed.emit(this.visible);
    }
  }

  ngAfterContentChecked() {
    this.dynamicTop = '14vh';
  }
}
